import Vue from 'vue'
import Vuex from 'vuex'

import PageHeaderStore from './modules/pageHeader/page-header-store'
import InfoStore from './modules/info/info-store'

Vue.use(Vuex)
export const store = new Vuex.Store({
  state: {
    overlays: {
      header: false,
      pageHeader: false,
      footer: false,
      main: false
    },
    useContentContainer: false,
    coursesWithLessonsToPrint: null
  },
  mutations: {
    SHOW_OVERLAY (state, name) {
      if (typeof name === 'string') {
        state.overlays[name] = true
      } else {
        for (const name in state.overlays) {
          state.overlays[name] = true
        }
      }
    },
    HIDE_OVERLAY (state, name) {
      if (typeof name === 'string') {
        state.overlays[name] = false
      } else {
        for (const name in state.overlays) {
          state.overlays[name] = false
        }
      }
    },
    SET_USE_CONTENT_CONTAINER (state, value) {
      state.useContentContainer = value
    },
    SET_COURSES_WITH_LESSONS_TO_PRINT (state, value) {
      state.coursesWithLessonsToPrint = value
    }
  },
  modules: { PageHeaderStore, InfoStore }
})
window.store = store
